import script from "./receptionRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./receptionRecord.vue?vue&type=script&setup=true&lang=js"

import "./receptionRecord.vue?vue&type=style&index=0&id=341f25c6&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341f25c6"]])

export default __exports__